/*
Add new lines to a subtitle text
*/
const addSpacesToText = (text: string, interval: number) => {
  let count = 0;
  let newText = "";
  for (let i = 0; i < text.length; i += 1) {
    newText += text[i];
    count += 1;

    if (count === interval) {
      newText += " ";
      count = 0;
    }

    if (text[i] === " ") {
      count = 0;
    }
  }
  return newText;
};

export default addSpacesToText;
